import React from 'react';
import { CirclePicker } from 'react-color';

import autoBind from 'react-autobind';
import MUIPlacesAutocomplete, { geocodeByPlaceID } from 'mui-places-autocomplete'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { grey } from '@material-ui/core/colors';
import MuiAlert from '@material-ui/lab/Alert';

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import Geocoder from 'composer/views/content/Geocoder.jsx'
import Config from "composer/Config.jsx";

import { Button, Grid, Icon, Slider, Tooltip, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Card, CardContent } from '@material-ui/core';
import {
  red,
} from '@material-ui/core/colors'

const styles = {
  card: {
    minHeight: 120,
  }
};

class LocaleDetailMapBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      minZoom: 3,
      maxZoom: 17,
      zoom: this.props.parent.state.zoom,
      mapSizeMessage: "",
      mapSizeReminder: "",
      mapZoomReminder: ""
    };
    autoBind(this);
  }

  mapZoomChanged = (event, value) => {
    this.setState({ zoom: value });
    this.state.zoom = value;
  }

  setMapZoom() {
    let zoom = this.state.zoom
    this.props.updateMapZoom(zoom);
  }

  zoomInMap() {
    let zoom = this.state.zoom;
    zoom++;
    if (zoom > this.state.maxZoom) {
      zoom = this.state.maxZoom;
    }
    this.setState({ zoom: zoom });
    this.state.zoom = zoom;
    this.setMapZoom();
  }

  zoomOutMap() {
    let zoom = this.state.zoom;
    zoom--;
    if (zoom < this.state.minZoom) {
      zoom = this.state.minZoom;
    }
    this.setState({ zoom: zoom });
    this.state.zoom = zoom;
    this.setMapZoom();
  }

  onSelected(viewport, item){
    const coordinates = {
      lat: item.center[1],
      lng: item.center[0],
    }

    this.props.parent.mapPanTo(coordinates);
  }

  onSuggestionSelected(suggestion) {
    geocodeByPlaceID(suggestion.place_id).then((results) => {
      // Add your business logic here. In this case we simply set our state with the coordinates of
      // the selected suggestion...

      // Just use the first result in the list to get the geometry coordinates
      const { geometry } = results[0]

      const coordinates = {
        lat: geometry.location.lat(),
        lng: geometry.location.lng(),
      }

      this.props.parent.mapPanTo(coordinates);
    }).catch((err) => {
      // Handle any errors that occurred when we tried to get geospatial data for a selected
      // suggestion...
    })
  }

  updateMapSize() {
    if (this.props.parent.state.viewState && this.props.parent.state.localeRect){
      let zoom = this.props.parent.state.viewState.zoom;

      let bounds = this.props.parent.state.localeRect.bounds;
      let upperLeft = this.props.parent.latLonToMeter(bounds.ul.lat, bounds.ul.lon);
      let bottomRight = this.props.parent.latLonToMeter(bounds.br.lat, bounds.br.lon);
      let width = parseInt(Math.abs(bottomRight.x - upperLeft.x));
      let height = parseInt(Math.abs(upperLeft.y - bottomRight.y));
      let message = width + "m * " + height + "m";
      let reminder = "";
      if (zoom < 14){
        reminder = Localization.strings.LOCALE_MAP_ZOOM_LV_REMINDER;
      }
      this.setState({
        mapSizeMessage: message,
        mapSizeReminder: reminder,
      });
      this.state.mapSizeMessage = message;
      this.state.mapSizeReminder = reminder;
    }
    if (this.props.parent.state.localeRect) {
      let bounds = this.props.parent.state.localeRect.bounds;
      let upperLeft = this.props.parent.latLonToMeter(bounds.ul.lat, bounds.ul.lon);
      let bottomRight = this.props.parent.latLonToMeter(bounds.br.lat, bounds.br.lon);
      let width = parseInt(Math.abs(bottomRight.x - upperLeft.x));
      let height = parseInt(Math.abs(upperLeft.y - bottomRight.y));
      let message = width + "m * " + height + "m";

      let reminder = "";
      if (width > this.props.parent.MaxLocaleMapSize() || height > this.props.parent.MaxLocaleMapSize()) {
        reminder = Localization.strings.LOCALE_MAP_MAX_SIZE_REMINDER;
      }
      else if (width < this.props.parent.MinLocaleMapSize() || height < this.props.parent.MinLocaleMapSize()) {
        reminder = Localization.strings.LOCALE_MAP_MIN_SIZE_REMINDER;
      }

      this.setState({
        mapSizeMessage: message,
        mapSizeReminder: reminder,
      });
      this.state.mapSizeMessage = message;
      this.state.mapSizeReminder = reminder;
    }
  }

  render() {
    return (
      <Grid container item xs={12} spacing={3}>
        <Grid item xs={12} sm={4}>
          <Card style={styles.card}>
            <CardContent>
              <Grid item xs={8} sm={8}>
                {Localization.strings.COLOR}
              </Grid>
              <Grid item xs={12} sm={12}>
                <ExpansionPanel>
                  <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>}>
                    <Icon style={{ color: '#'+this.props.parent.state.localeColor }}>lens</Icon>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <CirclePicker
                      color={this.props.parent.state.localeColor}
                      width="100%"
                      circleSize={20}
                      onChange={this.props.parent.localeColorChanged}
                    />
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card style={styles.card}>
            <CardContent>
              <Grid item xs={8} sm={8}>
                {Localization.strings.ZOOM}
              </Grid>
              <Grid item container xs={12}>
                <Grid container xs={12} spacing={3}>
                  <Grid item xs={12} sm={10}>
                    <Slider
                      defaultValue={this.state.zoom}
                      value={Math.round(this.state.zoom)}
                      aria-labelledby="discrete-slider"
                      valueLabelDisplay="auto"
                      marks
                      onChange={this.mapZoomChanged}
                      onChangeCommitted={this.setMapZoom}
                      min={this.state.minZoom}
                      max={this.state.maxZoom}
                      step={1}
                      style={{margin:'auto', width:"100%"}}
                      ref="zoomSlider"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    {Math.round(this.state.zoom)}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} sm={2}>
                <div style={{position:'absolute', display:'inline'}}>
                  {this.state.mapZoomReminder != '' && <MuiAlert elevation={6} variant="filled" severity='info'>{this.state.mapZoomReminder}</MuiAlert>}
                </div>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item container xs={12} sm={4} spacing={1}>
          <Grid item xs={12} sm={12}>
            <Grid item container xs={12} sm={12}>
              <Grid item xs={12} sm={12}>
                <Button
                  style={{bottom:"5px"}}
                  color="primary"
                  onClick={this.props.parent.localeMatchViewClicked}
                >
                  <Icon className="buttonIconLeft" >filter_center_focus</Icon>
                  Match View
                </Button>
                <Tooltip title={Localization.strings.MATCHVIEW_REMINDER} placement="bottom-end">
                  <HelpOutlineIcon
                    style={{ color: grey[300], top:"50px"}}
                    fontSize="small"
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  style={{bottom:"5px"}}
                  color="primary"
                  onClick={this.props.parent.localeTeleportClicked}
                >
                  <Icon className="buttonIconLeft">explore</Icon>
                  {Localization.strings.TELEPORT}
                </Button>
                <Tooltip title={Localization.strings.TELEPORT_REMINDER} placement="bottom-end">
                  <HelpOutlineIcon
                    style={{ color: grey[300] }}
                    fontSize="small"
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Geocoder
                  mapboxApiAccessToken={Config.MBOX_KEY()}
                  onSelected={this.onSelected}
                  hideOnSelect={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default LocaleDetailMapBar;
